import { render, staticRenderFns } from "./difficultyIndex.vue?vue&type=template&id=6d108230&"
import script from "./difficultyIndex.vue?vue&type=script&lang=js&"
export * from "./difficultyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d108230')) {
      api.createRecord('6d108230', component.options)
    } else {
      api.reload('6d108230', component.options)
    }
    module.hot.accept("./difficultyIndex.vue?vue&type=template&id=6d108230&", function () {
      api.rerender('6d108230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/CrmSetting/difficultyIndex.vue"
export default component.exports